/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as cartPageActions from '../../../../services/Cart/actions';
import * as addonActions from '../../../Addons/actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import { getPlansData } from '../../../../utils/plansReference';
import Loadable from '../../../../utils/loadable.js';
// import cartAddons from '../../../../components/Web/Cart/redesign/Components/FunctionalRedesign/cartAddons';
import { isWHWP2 } from '../../../../components/common/Helpers/index.js';

const cartAddons = Loadable(() =>
  isWHWP2()
    ? import('../../../../components/Web/Cart/redesign/Components/FunctionalRedesign/whwCartAddons')
    : import('../../../../components/Web/Cart/redesign/Components/FunctionalRedesign/cartAddons'),
);

const mapStateToProps = (state) => {
  const streamTVObj = state?.checkout?.lineDetails?.lineInfo?.newLine1?.accessories || {};
  const whwAccessory =
    state.cartDetails && state.cartDetails.cartDetailsJson.dueTodayList?.filter((obj) => obj.itemType?.toLowerCase()?.includes('accessory'));
  const whwObj = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature?.filter((obj) =>
    obj?.categoryCodes?.[0]?.toLowerCase()?.includes('whw'),
  );
  const whwDueMontly =
    state.cartDetails &&
    state.cartDetails.cartDetailsJson.dueMonthlyList &&
    state.cartDetails.cartDetailsJson.dueMonthlyList?.filter((obj) => obj?.itemType.includes('WHW'));
  // const whwObj = state.cartDetails && state.cartDetails.cartDetailsJson.dueMonthlyList ?

  const whwDueToday =
    state.cartDetails &&
    state.cartDetails.cartDetailsJson.dueTodayList &&
    state.cartDetails.cartDetailsJson.dueTodayList?.filter((obj) => obj?.itemType.includes('WHW'));
  // const whwObj = state.cartDetails && state.cartDetails.cartDetailsJson.dueMonthlyList ?

  const homeDeviceAdvisorObj = state?.checkout?.lineDetails?.lineInfo?.newLine1?.verizonHomeDeviceAdvisor || {};
  const homeProtectObj = state?.checkout?.lineDetails?.lineInfo?.newLine1?.verizonHomeProtect || {};
  const youTubeObj = state?.checkout?.lineDetails?.acctMcsSubscription || {};
  const homePhoneObj = state?.checkout?.lineDetails?.lineInfo?.newLine2?.serviceInfo?.newPricePlanInfo || {};
  const isHomePhone = state?.checkout?.lineDetails?.lineInfo?.newLine2?.deviceItem?.isHomePhone || false;
  const homePhoneMTN = state?.checkout?.lineDetails?.lineInfo?.newLine2?.mtnDetails?.npaNXX || '';
  const plansReferenceData = getPlansData(state.plansReferenceData);

  return {
    plansReferenceData: plansReferenceData || null,
    streamTVObj,
    whwObj,
    youTubeObj,
    homeDeviceAdvisorObj,
    homeProtectObj,
    homePhoneObj,
    isHomePhone,
    homePhoneMTN,
    whwAccessory,
    whwDueMontly,
    whwDueToday,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartPageActions, ...addonActions, ...loaderActions }, dispatch);
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withRouter(compose(withConnect)(cartAddons));
